import { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

export const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { href: '#about', label: 'Über uns' },
    { href: '#services', label: 'Leistungen' },
    { href: '#references', label: 'Referenzen' },
    { href: '#contact', label: 'Kontakt' },
  ];

  const handleNavClick = (e, href) => {
    if (!isHomePage) {
      e.preventDefault();
      window.location.href = '/' + href;
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || isMobileMenuOpen ? 'bg-white shadow-md py-3' : 'bg-transparent py-4'
      }`}
      data-testid="navigation"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link
            to="/"
            className={`text-xl sm:text-2xl font-bold tracking-tight transition-colors ${
              isScrolled || isMobileMenuOpen ? 'text-[#003366]' : 'text-white'
            }`}
            data-testid="nav-logo"
          >
            KayaClean
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => handleNavClick(e, link.href)}
                className={`font-medium transition-colors hover:text-[#00BFFF] ${
                  isScrolled ? 'text-slate-700' : 'text-white'
                }`}
                data-testid={`nav-link-${link.href.replace('#', '')}`}
              >
                {link.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={(e) => handleNavClick(e, '#contact')}
              className="bg-[#003366] hover:bg-[#002244] text-white px-6 py-2 h-10 flex items-center rounded-sm font-semibold transition-all btn-lift"
              data-testid="nav-cta-btn"
            >
              Anfrage stellen
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden p-2 ${isScrolled || isMobileMenuOpen ? 'text-[#003366]' : 'text-white'}`}
            aria-label="Toggle menu"
            data-testid="mobile-menu-btn"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu - White Background */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-slate-200 bg-white" data-testid="mobile-menu">
            <div className="flex flex-col gap-4 pt-4">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => handleNavClick(e, link.href)}
                  className="font-medium text-slate-700 hover:text-[#003366] transition-colors"
                >
                  {link.label}
                </a>
              ))}
              <a
                href="#contact"
                onClick={(e) => handleNavClick(e, '#contact')}
                className="bg-[#003366] hover:bg-[#002244] text-white px-6 py-3 rounded-sm font-semibold text-center"
              >
                Anfrage stellen
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
